import React from "react";
import WishlistButton from "./WishlistButton";
function Men(){
    return <div className="Men">

    <div className ="mencard">
 <div className="catalog-section-title"> <h1>Mens Formal Shirts</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Checkered Casual Shirt.jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Men Checkered Casual Shirt</h6>
<p></p>
<h4> ₹599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Checkered Casual Cut Away Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Men Checkered Casual Cut Away Shirt</h6><h4> ₹599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Solid Casual Slim Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Men Solid Casual Slim Shirt</h6><h4> ₹549 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Solid Casual Tie up Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Men Solid Casual Tie up Shirt</h6><h4> ₹549 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Solid Casual Mandarin Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Men Solid Casual Mandarin Shirt</h6><h4> ₹799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Solid Casual Spread Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Men Solid Casual Spread Shirt</h6><h4> ₹549 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Solid Casual Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Men Solid Casual Shirt</h6><h4> ₹649 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Peter England University Men Checkered Casual Spread Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Peter England University Men Checkered Casual Spread Shirt</h6><h4> ₹1,169 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Men Checkered Casual Regular Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Men Checkered Casual Regular Shirt</h6><h4> ₹599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Dennis Lingo Men Solid Casual Spread Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Dennis Lingo Men Solid Casual Spread Shirt</h6><h4> ₹549 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Hinlander Men Solid Casual Mandarin Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Hinlander Men Solid Casual Mandarin Shirt</h6><h4> ₹1499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Gipso Men Solid Casual Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Gipso Men Solid Casual Shirt</h6><h4> ₹799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Metronaut Men Checkered Casual Spread Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Metronaut Men Checkered Casual Spread Shirt</h6><h4> ₹1,031 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Highlander Men Checkered Casual Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Highlander Men Checkered Casual Shirt</h6><h4> ₹599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Hinlander Men Checkered Casual Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Hinlander Men Checkered Casual Shirt</h6><h4> ₹1,349 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Dennis Lingo Men Solid Casual Spread Shirts.jpeg"}alt=""  /></div>
<div className="card-header">
<h6>Dennis Lingo Men Solid Casual Spread Shirts</h6><h4> ₹1,449 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
 </div>

<div className ="mencard">
 <div className="catalog-section-title"> <h1>Mens Casual Phants</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Regular Fit Men Blue Polyester Viscose Blend Trousers.jpeg"} alt="" /></div>
<div className="card-header"><h6>Regular Fit Men Blue Polyester Viscose Blend Trousers</h6><h4> ₹588 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Regular Fit Men Black Cotton Blend Trousers.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Regular Fit Men Black Cotton Blend Trousers</h6><h4> ₹544 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Wrangler Slim Fit Men Khaki Cotton Blend Trousers.jpeg"} alt="" /></div>
<div className="card-header"><h6>Wrangler Slim Fit Men Khaki Cotton Blend Trousers</h6><h4> ₹1,599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Regular Fit Men Grey Polyester Blend Trousers.jpeg"} alt="" /></div>
<div className="card-header"><h6>Regular Fit Men Grey Polyester Blend Trousers</h6><h4> ₹1,379 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Peter England Slim Fit Men Blue Cotton Blend Trousers.jpeg"}alt=""  /></div>
<div className="card-header">
<h6>Peter England Slim Fit Men Blue Cotton Blend Trousers</h6><h4> ₹1,179 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Slim Fit Men Polyester Viscose Blend Grey Polyester Viscose Blend Trousers.jpeg"} alt="" /></div>
<div className="card-header"><h6>Slim Fit Men Polyester Viscose Blend Grey Polyester Viscose Blend Trousers</h6><h4> ₹969 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Peter England en White Cotton Blend Trousers.jpeg"} alt="" /></div>
<div className="card-header">
<h6>Peter England en White Cotton Blend Trousers</h6><h4> ₹1,329 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Raymond Slim Fit Men Black Polyester Viscose Blend Trousers.jpeg"} alt="" /></div>
<div className="card-header"><h6>Raymond Slim Fit Men Black Polyester Viscose Blend Trousers</h6><h4> ₹1,266 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Printed Men Green Chino Shorts.jpeg"} alt="" /></div>
<div className="card-header"><h6>Printed Men Green Chino Shorts</h6><h4> ₹696 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Printed Men Green Chino Shorts.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Printed Men Green Chino Shorts</h6><h4> ₹696 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Checkered Men Multicolor Boxer Shorts.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Checkered Men Multicolor Boxer Shorts</h6><h4> ₹492 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Applique Men Dark Blue Track Pants.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Applique Men Dark Blue Track Pants</h6><h4> ₹645</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Solid Men Three Fourths.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Solid Men Three Fourths</h6><h4> ₹899</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Solid Men Black Track Pants.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Solid Men Black Track Pants</h6><h4> ₹699</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Solid Men Three Fourth.jpeg"} alt="" /></div>
<div className="card-header"><h6> Solid Men Three Fourth</h6><h4> ₹599</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Peter England Solid Men Brown Chino Shorts.jpeg"}alt=""  /></div>
<div className="card-header"><h6> Peter England Solid Men Brown Chino Shorts</h6><h4> ₹899</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
 </div>
 
 <div className ="mencard">
 <div className="catalog-section-title"> <h1>Mens T-Shirts</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Color Block Men Round Neck Green, Black T-Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Color Block Men Round Neck Green, Black T-Shirt</h6><h4> ₹499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Color Block Men Round Neck Orange T-Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Color Block Men Round Neck Orange T-Shirt</h6><h4> ₹599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Solid Men Round Neck Black T-Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Solid Men Round Neck Black T-Shirt</h6><h4> ₹489 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Solid Men Round Neck White T-Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Solid Men Round Neck White T-Shirt</h6><h4> ₹699 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Striped Men Hooded Neck Red, Black T-Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Striped Men Hooded Neck Red, Black T-Shirt</h6><h4> ₹499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Color Block Men Hooded Neck White, Blue, Yellow T-Shirt.jpeg"} alt="" /></div>
<div className="card-header"><h6>Color Block Men Hooded Neck White, Blue, Yellow T-Shirt</h6><h4> ₹649 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Color Block Men Round Neck White, Black T-Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Color Block Men Round Neck White, Black T-Shirt</h6><h4> ₹599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="menimage"src={process.env.PUBLIC_URL + "/images/menimages/Solid Men Round Neck Orange T-Shirt.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Solid Men Round Neck Orange T-Shirt</h6><h4> ₹499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 </div>
 </div>
 
 </div>
}
export default Men;